import Presentation from "./presentation/Presentation";
import s from "./style.module.css";
import React from "react";

export default function Acceuil() {
  return (
    <>
      <div className={`row p-0 m-0 ${s.relative}`}>
        <div className={`col-12 col-lg-6 order-2 order-lg-1 ${s.miniBox}`}>
          <Presentation />
        </div>
        <div className={`col-12 col-lg-6 order-1 order-lg-2 ${s.miniBoxImg}`}>
          <div className={`${s.miniBoxImg}`}>
            <img
              className={`${s.croix}`}
              src="/assets/croix.webp"
              alt="croix"
            />
            <img
              className={`${s.me}`}
              src="/assets/meAccueil.webp"
              alt="Avatar Charly Hazard"
            />
            <div className={`${s.welcome}`}>
              WELCOM<span className={`${s.welcomeNoSpacing}`}>E</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
